var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "attribute-table uk-table uk-table-divider uk-table-justify"
  }, [_c('tbody', _vm._l((_vm.fieldsOrDefaultFields), function(field) {
    return _c('tr', [_c('td', {
      staticClass: "attribute-table__key uk-table-shrink uk-text-right uk-text-bold",
      attrs: {
        "title": _vm.$t(("fields." + field))
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$t(("fields." + field))) + "\n      ")]), _vm._v(" "), _c('td', {
      staticClass: "attribute-table__value"
    }, [_vm._t(field, [(_vm.data[field]) ? _c('span', [_vm._v(_vm._s(_vm.data[field]))]) : _c('span', [_c('text-placeholder')], 1)], {
      value: _vm.data[field],
      row: _vm.data
    })], 2)])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7581a966","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AttributeTable.vue
// module id = 2059
// module chunks = 0